import React, { useState, useEffect } from "react";
import "./faq.css";
import AOS from "aos";
import "aos/dist/aos.css";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // Toggle Question
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Initialize AOS Animation
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  // ---- Fazo Academy FAQs ----
  const academyFAQs = [
    {
      q: "1. What programs does Fazo Academy offer?",
      a: "Fazo Academy offers a wide range of programs including software development, data science, digital marketing, and more. Our flagship program is the testing training course.",
    },
    {
      q: "2. Are the courses at Fazo Academy accredited?",
      a: "Yes, our courses are accredited and recognized within the industry. We maintain high standards of education and curriculum development.",
    },
    {
      q: "3. Is financial aid available for students?",
      a: "Yes, Fazo Academy offers flexible payment options and financial aid for eligible students, including scholarships and grants.",
    },
    {
      q: "4. Are there any prerequisites for enrolling in courses?",
      a: "Prerequisites vary depending on the course. Some may require prior knowledge or experience. Our counselors can guide you accordingly.",
    },
    {
      q: "5. Do you offer job placement assistance?",
      a: "Yes, Fazo Academy provides job placement assistance through career services, resume workshops, and interview training.",
    },
  ];

  // ---- Automation Testing FAQs ----
  const pythonFullStackFAQs = [
  {
    q: "1. What is the Python Full Stack Course at Fazo Academy?",
    a: "The Python Full Stack Course at Fazo Academy is a comprehensive training program designed to teach students the fundamentals of both front-end and back-end web development using Python. You'll learn web frameworks like Django and Flask, along with front-end technologies such as HTML, CSS, JavaScript, and React."
  },
  {
    q: "2. Who is the Python Full Stack Course suitable for?",
    a: "The Python Full Stack Course is suitable for beginners who are new to web development, as well as experienced developers looking to expand their skills in Python and full-stack development. Whether you're starting your programming journey or aiming to become a full-stack developer, this course provides a solid foundation in both front-end and back-end technologies."
  },
  {
    q: "3. What will I learn in the Python Full Stack Course?",
    a: "Throughout the course, you will learn core concepts of full-stack web development, including front-end technologies (HTML, CSS, JavaScript, React) and back-end development using Python frameworks (Django, Flask). You'll also gain practical experience in building and deploying full-stack applications, along with best practices in development and project management."
  },
  {
    q: "4. Are there any prerequisites for enrolling in the Python Full Stack Course?",
    a: "There are no specific prerequisites for enrolling in the Python Full Stack Course. However, basic knowledge of programming concepts and a willingness to learn are recommended. The course is designed to take you step-by-step through the fundamentals of full-stack development, regardless of your prior experience."
  },
  {
    q: "5. Is the Python Full Stack Course available online or in-person?",
    a: "Fazo Academy offers both online and in-person options for the Python Full Stack Course. You can choose the format that best fits your schedule and learning preferences."
  },
  {
    q: "6. How long is the Python Full Stack Course?",
    a: "The duration of the Python Full Stack Course varies depending on the format (full-time or part-time) and specific schedule. Typically, the course lasts several weeks to a few months, allowing students to progress at a comfortable pace while covering all the necessary concepts in both front-end and back-end development."
  },
  {
    q: "7. What career opportunities can I pursue after completing the Python Full Stack Course?",
    a: "Graduates of the Python Full Stack Course can pursue a variety of career paths, including Full Stack Developer, Web Developer, Front-End Developer, Back-End Developer, and Software Engineer. With Python being in high demand for web development, you’ll have opportunities in industries such as software development, e-commerce, tech startups, and more."
  },
  {
    q: "8. Does Fazo Academy offer job placement assistance for graduates of the Python Full Stack Course?",
    a: "Yes, Fazo Academy provides job placement assistance to graduates of the Python Full Stack Course. Our career services team helps with resume building, interview preparation, and connects you with an extensive network of employers in the tech industry to help you secure a job as a full-stack developer."
  }
];
  // ---- Training Method FAQs ----
  const trainingFAQs = [
    {
      q: "1. What training methods does Fazo Academy use?",
      a: "We use interactive lectures, projects, peer collaboration, mentorship, and flexible learning options.",
    },
    {
      q: "2. Are the lectures interactive?",
      a: "Yes, our lectures encourage active engagement and collaboration between students and instructors.",
    },
    {
      q: "3. How are hands-on projects incorporated?",
      a: "Projects simulate real-world challenges to reinforce learning and build strong portfolios.",
    },
    {
      q: "4. Is peer collaboration encouraged?",
      a: "Yes, team collaboration helps share knowledge and improve learning outcomes.",
    },
    {
      q: "5. Do students receive one-on-one mentorship?",
      a: "Yes, personalized mentorship is part of every student’s journey at Fazo Academy.",
    },
    {
      q: "6. How is the curriculum updated?",
      a: "Our curriculum is regularly revised to reflect the latest industry technologies and best practices.",
    },
    {
      q: "7. Does Fazo Academy offer flexible learning options?",
      a: "Yes, we offer part-time, full-time, online, and in-person training modes.",
    },
    {
      q: "8. Are there opportunities for practical application?",
      a: "Absolutely. Students work on coding exercises, simulations, and real-world case studies.",
    },
  ];

  const categories = [
    { title: "FAQs about Fazo Academy", data: academyFAQs },
    { title: "FAQs about Python Course", data: pythonFullStackFAQs },
    { title: "FAQs about Training Methods", data: trainingFAQs },
  ];

  return (
    <div className="faq-section-one">
      <div className="container">
        <section className="section-margin" data-aos="fade-up">
          <div className="headlines-for-all">
            <h4>
              <span>Frequently</span> Asked Questions
            </h4>
            <p>
              Find answers to the most common questions about our courses,
              learning process, certifications, and career support.
            </p>
          </div>
        </section>

        <div className="faq-container">
          {categories.map((cat, catIndex) => (
            <div
              className="faq-category"
              key={catIndex}
              // data-aos="fade-up"
              // data-aos-delay={catIndex * 200}
            >
              <h2 className="faq-title">{cat.title}</h2>

              {cat.data.map((item, index) => {
                const itemIndex = `${catIndex}-${index}`;
                const isOpen = openIndex === itemIndex;

                return (
                  <div className="faq-item" key={itemIndex}>
                    <button
                      className={`faq-question ${isOpen ? "active" : ""}`}
                      onClick={() => toggleFAQ(itemIndex)}
                      // data-aos="fade-up"
                    >
                      {item.q}
                      <span className="arrow">{isOpen ? "▲" : "▼"}</span>
                    </button>

                    <div
                      className="faq-answer"
                      style={{
                        maxHeight: isOpen ? "500px" : "0",
                        opacity: isOpen ? "1" : "0",
                        transition: "all 0.4s ease",
                      }}
                    >
                      <p>{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
